import { useEffect, useState } from "react";

const API_BASE = process.env.REACT_APP_NAV_API;
export default function CumulativeCard() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

useEffect(() => {

  // ✅ Initial load
  fetchData();

  // ✅ Auto refresh every 10 mins
  const interval = setInterval(() => {

    console.log("Refreshing cumulative score...");

    fetchData();

  }, 10 * 60 * 1000);

  return () => clearInterval(interval);

}, []);
  async function fetchData() {
    try {
      setLoading(true);

      const res = await fetch(`${API_BASE}/pending/summary`, {
        credentials: "include"
      });

      const json = await res.json();

      if (json.ok) {
        setData(json.data || []);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <div className="card">Loading cumulative...</div>;

  if (!data.length) {
    return (
      <div className="card">
        <b>No Cumulative Score</b>
      </div>
    );
  }

return (
  <div className="card">

    <div
      className="cardTitle"
      style={{
        fontSize: "13px",
        fontWeight: 700
      }}
    >
      📊 Overall Performance Score
    </div>

    {[...data]
      .sort((a, b) =>
        (a.Department || "").localeCompare(b.Department || "")
      )
      .map((r, i) => (
        <div
          key={i}
          style={{
            marginTop: 8,
            fontSize: "12px"
          }}
        >
          <b>{r.Department}</b>

          <div style={{ fontSize: "12px" }}>
            Cumulative:{" "}

            <span
              style={{
                fontWeight: 700,
                backgroundColor:
                  Number(r.Cumulative_Total_Average_Score) <= -20
                    ? "#ef4444"
                    : "#22c55e",
                color: "#000",
                padding: "3px 6px",
                borderRadius: "6px",
                display: "inline-block",
                minWidth: "60px",
                textAlign: "center",
                fontSize: "11px"
              }}
            >
              {Number(
                r.Cumulative_Total_Average_Score || 0
              ).toFixed(2)}
            </span>
          </div>

          {r.Cumulative_Date_Range && (
            <div
              className="mutedSmall"
              style={{
                fontSize: "11px"
              }}
            >
              {r.Cumulative_Date_Range}
            </div>
          )}
        </div>
      ))}
  </div>
);
}